import React from 'react';

const SECENEKLER = [
  { id: '1ay', label: '1 ay' },
  { id: '3ay', label: '3 ay' },
  { id: '6ay', label: '6 ay' },
  { id: '1yil', label: '1 yıl' },
  { id: '5yil', label: '5 yıl' },
];

const DonemSecici = ({ value, onChange }) => (
  <div className="ia-donem" role="radiogroup" aria-label="Dönem">
    {SECENEKLER.map((s) => (
      <button
        key={s.id}
        type="button"
        role="radio"
        aria-checked={value === s.id}
        className={`ia-donem-btn ${value === s.id ? 'active' : ''}`}
        onClick={() => onChange(s.id)}
      >
        {s.label}
      </button>
    ))}
  </div>
);

export default DonemSecici;
